import { formatMoney } from '@kidshome/i18n';
import { cn } from '@kidshome/ui';
import { useHouseholdContext } from '@/shared/lib/household';

/**
 * Real money (allowance / cash / savings / ledger), formatted via the `Intl` currency wrapper with an
 * explicit sign when requested. Amounts are minor units (cents). `currency` overrides the household
 * default for per-row ledger entries that carry their own currency.
 */
export function Money({
  amountMinor,
  currency,
  signed = false,
  className,
}: {
  amountMinor: number;
  currency?: string;
  signed?: boolean;
  className?: string;
}): React.ReactElement {
  const { locale, currency: householdCurrency } = useHouseholdContext();
  const text = formatMoney(locale, amountMinor, currency ?? householdCurrency, {
    signDisplay: signed ? 'always' : 'auto',
  });
  return <span className={cn('tabular-nums', className)}>{text}</span>;
}
